import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import button from '../../button';
import { Icon, Box, Stack } from 'react-spark';
import { round } from '../../../helpers/filters';
import actionCreator from '../../redux/offer/action-creator';
import stateSelectors from '../../redux/offer/state-selectors';
import { offerKeySchema, offerSchema } from '../../offers-page-schemas';
import { FormattedNumber } from 'react-intl';
import Tooltip from '../../tooltip/Tooltip';

const { baseButton: Button } = button;

export class OfferComponent extends Component {
    aprTooltipText() {
        return (
            <Fragment>
        This is based off of the rate of the loan,{' '}
                <FormattedNumber value={this.props.value.rate/100}
                    style="percent"
                    minimumFractionDigits={3}
                    maximumFractionDigits={3}/>
        , and an origination fee of{' '}
                <FormattedNumber value={this.props.value.originationFeeRate/100}
                    style="percent"
                    minimumFractionDigits={3}
                    maximumFractionDigits={3}/>
                {' '}(
                <FormattedNumber value={this.props.value.originationFee}
                    style="currency"
                    currency="USD" />){' '}
        which will be deducted from the proceeds of the loan. These numbers are an estimate.
            </Fragment>);
    }

    render() {
        const { heading, keyName, value, detailedInfo, selectOffer, isSelectingOffer } = this.props;

        return (
            <Fragment>
                <div className="offer sm-show">
                    <div className="offer__header sprk-u-TextAlign--left">
                        <p id="offerHeading" className="sprk-b-TypeBodyTwo sprk-u-man">
                            {detailedInfo ? 'Loan Amount' : heading}
                        </p>
                        <p
                            id="headingTerm"
                            className="offer__details-term sprk-b-TypeDisplayThree sprk-u-FontWeight--bold sprk-u-man"
                        >
                            {detailedInfo && '$'}{detailedInfo && <FormattedNumber value={value.amount} style="decimal" maximumFractionDigits={0} />}
                            {!detailedInfo && `${value.duration} Month Term`}
                        </p>
                    </div>
                    <Box padding="small">
                        <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--left"
                            >
                                <p className="offer__details-header sprk-b-TypeDisplayFive sprk-u-man">
                  Monthly Payment
                                </p>
                            </Stack.Item>
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--right"
                            >
                                <p className="offer__details-amount sprk-b-TypeDisplayFive sprk-u-FontWeight--bold sprk-u-man">
                                    <FormattedNumber
                                        value={value.monthlyPayment}
                                        currency="USD"
                                        style="currency"
                                        id="monthlyPayment"
                                    />
                  /month
                                </p>
                            </Stack.Item>
                        </Stack>
                        {detailedInfo && <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--left"
                            >
                                <p className="offer__details-header sprk-b-TypeDisplayFive sprk-u-man">
                                    <span>
                    Term
                                    </span>
                                </p>
                            </Stack.Item>
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--right"
                            >
                                <p className="offer__details-rate sprk-b-TypeDisplayFive sprk-u-FontWeight--bold sprk-u-man">
                                    {value.duration} Mo.
                                </p>
                            </Stack.Item>
                        </Stack>}
                        <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--left"
                            >
                                <p className="offer__details-rate-heading sprk-b-TypeDisplayFive sprk-u-man">
                                    <span>
                    Autopay Rate{' '}
                                        <Tooltip
                                            id="offer-autopayrate-tooltip"
                                            text="Autopay is a secure, easy and convenient way to make payments directly from your bank account each month. Enrolling guarantees you a .3% discount off of your rate."
                                        >
                                            <Icon name="question" />
                                        </Tooltip>
                                    </span>
                                </p>
                            </Stack.Item>
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--right"
                            >
                                <p className="offer__details-rate sprk-b-TypeDisplayFive sprk-u-FontWeight--bold sprk-u-man">
                                    {round(value.rate, 3)}%
                                </p>
                            </Stack.Item>
                        </Stack>
                        <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--left"
                            >
                                <p className="offer__details-rate-heading sprk-b-TypeDisplayFive sprk-u-man">
                                    <span>
                    APR{' '}
                                        <Tooltip
                                            id="offer-apr-tooltip"
                                            text={this.aprTooltipText()}
                                        >
                                            <Icon name="question" />
                                        </Tooltip>
                                    </span>
                                </p>
                            </Stack.Item>
                            <Stack.Item
                                breakpoint="tiny"
                                width="half"
                                className="offer__details sprk-u-TextAlign--right"
                            >
                                <p className="offer__details-rate sprk-b-TypeDisplayFive sprk-u-FontWeight--bold sprk-u-man">
                                    {round(value.annualPercentageRate, 3)}%
                                </p>
                            </Stack.Item>
                        </Stack>
                    </Box>
                    <Stack
                        splitAt="tiny"
                        className="offer__details sprk-u-AbsoluteCenter"
                    >
                        <Stack.Item
                            breakpoint="tiny"
                            className="offer__details"
                        >
                            <Button
                                id={`${value.duration}MonthSelectButton`}
                                name={`${value.duration}MonthSelectButton`}
                                onClick={() => selectOffer(keyName)}
                                disabled={isSelectingOffer}
                            >
                Select
                            </Button>
                        </Stack.Item>
                    </Stack>
                </div>

                <div className="sm-hide">
                    <div className="offer">
                        <div className="offer__header sprk-u-TextAlign--left">
                            <p id="offerHeading" className="sprk-b-TypeBodyTwo">
                                {detailedInfo ? 'Loan Amount' : heading}
                            </p>
                            <p
                                id="headingTerm"
                                className="offer__details-term sprk-b-TypeDisplayFour sprk-u-FontWeight--bold sprk-u-man"
                            >
                                {detailedInfo && '$'}{detailedInfo && <FormattedNumber value={value.amount} style="decimal" maximumFractionDigits={0} />}
                                {!detailedInfo && `${value.duration} Month Term`}
                            </p>
                        </div>
                        <Box padding="small">
                            <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--left"
                                >
                                    <p className="offer__details-header sprk-b-TypeDisplaySeven sprk-u-man">
                    Monthly Payment
                                    </p>
                                </Stack.Item>
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--right"
                                >
                                    <p className="offer__details-amount sprk-b-TypeDisplaySeven sprk-u-FontWeight--bold sprk-u-man">
                                        <FormattedNumber
                                            value={value.monthlyPayment}
                                            currency="USD"
                                            style="currency"
                                        />
                    /month
                                    </p>
                                </Stack.Item>
                            </Stack>
                            {detailedInfo && <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--left"
                                >
                                    <p className="offer__details-header sprk-b-TypeDisplaySeven sprk-u-man">
                                        <span>
                        Term
                                        </span>
                                    </p>
                                </Stack.Item>
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--right"
                                >
                                    <p className="offer__details-rate sprk-b-TypeDisplaySeven sprk-u-FontWeight--bold sprk-u-man">
                                        {value.duration} Mo.
                                    </p>
                                </Stack.Item>
                            </Stack>}
                            <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--left"
                                >
                                    <p className="offer__details-rate-heading sprk-b-TypeDisplaySeven sprk-u-man">
                                        <span>
                        Autopay Rate{' '}
                                            <Tooltip
                                                id="offer-autopayrate-tooltip"
                                                text="Autopay is a secure, easy and convenient way to make payments directly from your bank account each month. Enrolling guarantees you a .3% discount off of your rate."
                                            >
                                                <Icon name="question" />
                                            </Tooltip>
                                        </span>
                                    </p>
                                </Stack.Item>
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--right"
                                >
                                    <p className="offer__details-rate sprk-b-TypeDisplaySeven sprk-u-FontWeight--bold sprk-u-man">
                                        {round(value.rate, 3)}%
                                    </p>
                                </Stack.Item>
                            </Stack>
                            <Stack splitAt="tiny" className="offer__details sprk-u-phn">
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--left"
                                >
                                    <p className="offer__details-rate-heading sprk-b-TypeDisplaySeven sprk-u-man">
                                        <span>
                        APR{' '}
                                            <Tooltip
                                                id="offer-apr-tooltip"
                                                text={this.aprTooltipText()}
                                            >
                                                <Icon name="question" />
                                            </Tooltip>
                                        </span>
                                    </p>
                                </Stack.Item>
                                <Stack.Item
                                    breakpoint="tiny"
                                    width="half"
                                    className="offer__details sprk-u-TextAlign--right"
                                >
                                    <p className="offer__details-rate sprk-b-TypeDisplaySeven sprk-u-FontWeight--bold sprk-u-man">
                                        {round(value.annualPercentageRate, 3)}%
                                    </p>
                                </Stack.Item>
                            </Stack>
                        </Box>
                        <Stack
                            splitAt="tiny"
                            className="offer__details sprk-u-AbsoluteCenter"
                        >
                            <Stack.Item
                                className="offer__details"
                            >
                                <Button
                                    id={`${value.duration}MonthSelectButton`}
                                    name={`${value.duration}MonthSelectButton`}
                                    onClick={() => selectOffer(keyName)}
                                    disabled={isSelectingOffer}
                                >
                    Select
                                </Button>
                            </Stack.Item>
                        </Stack>
                    </div>
                </div>
            </Fragment>
        );
    }
}

OfferComponent.defaultProps = {
    detailedInfo: false
};

OfferComponent.propTypes = {
    heading: PropTypes.string.isRequired,
    keyName: offerKeySchema.isRequired,
    value: offerSchema.isRequired,
    selectOffer: PropTypes.func.isRequired,
    isSelectingOffer: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const offerSelecting = stateSelectors.getOfferSelecting(state);
    return {
        isSelectingOffer: offerSelecting ? offerSelecting : false,
    };
};

const mapDispatchToProps = (dispatch) => ({
    selectOffer: (offerId) => dispatch((_, getState) => {
        const state = getState();
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            dispatch(actionCreator.selectOfferAuthenticated(offerId, state.loan.loanJson.loanId));
        } else {
            dispatch(actionCreator.selectOffer(offerId))
        }
    }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OfferComponent);
